import React, { useState } from 'react'

import Section from '../../../react4xp/components/Section'
import Image from '../../../react4xp/components/Image'
import Button from '../../../react4xp/components/Button'
import Link from '../../../react4xp/components/Link'
import RichText from '../../../react4xp/components/RichText'

import { UxArrowRight } from '../../../react4xp/components/Svg/Ux/Arrow'
import { GeneralLink } from '../../../react4xp/components/Svg/Icons/General'

function ArticleLayout({ title, date, intro, cta, image, text, strings }) {
  // copy url
	const [showTooltip, setShowTooltip] = useState(false)
	
	const copyToClipboard = () => {
		navigator.clipboard.writeText(location.href)
		setShowTooltip(true)
    	setTimeout(() => setShowTooltip(false), 3000)
	}

  return (
    <>
      <Section
        paddingTop='small'
        paddingBottom='smaller'
        className='page-article__header'
      >
        <div className='container'>
          <div className='row'>

            {
              image.large &&
              <div className='col-lg-10 offset-lg-1'>
                <div className='page-article__header__image'>
                  <Image
                    src={image.large.link} // 1080x520
                    srcMedium={image.medium.link} // 850x400
                    srcSmall={image.small.link} // 500x250
                    alt={image.large.alt}
                    className='cover'
                  />
                </div>
              </div>
            }

            <div className='col-lg-10 offset-lg-1 col-xl-8 offset-xl-2'>

              <h1 className='page-article__header__title h1'>
                {title}
              </h1>

              <div className='page-article__header__link'>
                <Link
                  data-tooltip={strings.linkCopied}
                  onClick={copyToClipboard}
                  text={strings.shareArticle}
                  iconPosition='left'
                  icon={<GeneralLink variant='outline' />}
                  className={showTooltip ? 'tooltip-visible' : ''}
                />
              </div>

              {
                intro &&
                <RichText
                  className='page-article__header__intro text-big'
                  content={intro}
                />
              }

              {
                cta.text &&
                <div className='page-article__header__buttons'>
                  {
                    cta.style == 'button' &&
                    <Button
                      hasBorders
                      hover='blue'
                      noUnderline
                      href={cta.href}
                      target={cta.external}
                    >
                      {cta.text}
                    </Button>
                  }
                  {
                    cta.style == 'link' &&
                    <Link
                      text={cta.text}
                      href={cta.href}
                      icon={<UxArrowRight />}
                      iconPosition='right'
                      target={cta.external}
                    />
                  }

                </div>
              }

            </div>
          </div>
        </div>
      </Section>

      <Section
        className='page-article__body'
        paddingTop='none'
        paddingBottom='big'
      >
        <div className='container'>
          <div className='row'>
            <div className='col-md-10 col-lg-8 offset-lg-1 col-xl-6 offset-xl-2 page-article__body__content'>

              <RichText
                content={text}
              />

            </div>
          </div>
        </div>
      </Section>
    </>
  )
}

export default (props) => <ArticleLayout {...props} />
